import { render } from "./DressCodeModal.vue?vue&type=template&id=253c5244"
import script from "./DressCodeModal.vue?vue&type=script&lang=js"
export * from "./DressCodeModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__